import React, { useState } from 'react';
import EmailIntegrationComponent from './EmailIntegrationComponent';
import { Box } from '@mui/system';

const EmailIntegration = () => {
    return (
        <Box sx={{ marginTop: 3 }}>
            <EmailIntegrationComponent />
        </Box>
    );
};

export default EmailIntegration;
